module.exports = __webpack_public_path__ + "img/USACH_2.2f7fc05a.jpg";